import Login from "components/Authentication/Login";

export default function Home() {
  return <Login />;
}
